import { useEffect, useState } from "react";

export default function useEventHandler(initValue = "", customOnChange) {
  const [localValue, setLocalValue] = useState(initValue);

  useEffect(() => {
    setLocalValue(initValue ?? null);
  }, [initValue]);

  const handleOnInputChange = (event, customOnChange, fieldName) => {
    const rawValue = event?.target?.value;
    const fieldValue =
      rawValue === "" || rawValue === undefined || rawValue === null ? null : rawValue;
    setLocalValue(fieldValue);
    customOnChange(fieldName, fieldValue);
  };

  const handleOnClearInput = (fieldName) => {
    setLocalValue("");
    customOnChange(fieldName, null);
  };
  return { handleOnInputChange, handleOnClearInput, localValue, setLocalValue };
}
